// src/icons/Lock.tsx
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function Lock({ strokeWidth = "2" }) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 21 22",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M1 14.1429C1 12.5427 1 11.7426 1.34469 11.1315C1.64789 10.5938 2.13169 10.1568 2.72675 9.88284C3.40324 9.57143 4.28882 9.57143 6.05998 9.57143H14.9149C16.6861 9.57143 17.5717 9.57143 18.2482 9.88284C18.8432 10.1568 19.327 10.5938 19.6302 11.1315C19.9749 11.7426 19.9749 12.5427 19.9749 14.1429V16.4286C19.9749 18.0287 19.9749 18.8288 19.6302 19.44C19.327 19.9776 18.8432 20.4147 18.2482 20.6886C17.5717 21 16.6861 21 14.9149 21H6.05998C4.28882 21 3.40324 21 2.72675 20.6886C2.13169 20.4147 1.64789 19.9776 1.34469 19.44C1 18.8288 1 18.0287 1 16.4286V14.1429Z",
            stroke: "currentColor",
            strokeWidth
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M4.5821 9.57143L4.5821 5.28572C4.5821 3.95445 4.5821 3.28882 4.82283 2.76376C5.1438 2.06368 5.75945 1.50747 6.53435 1.21749C7.11552 1 9.01392 1 10.4875 1C11.961 1 13.4884 1 14.0696 1.21749C14.8445 1.50747 15.4601 2.06368 15.7811 2.76376C16.0218 3.28882 16.0218 3.95445 16.0218 5.28571V9.57143H4.5821Z",
            stroke: "currentColor",
            strokeWidth
          }
        )
      ]
    }
  );
}

export {
  Lock
};
